<template>
  <section
    v-if="isVisible"
    :class="[`dialog-container`, props.className]"
    :style="{ width: width, height: height, ...style }"
  >
    <slot></slot>

    <button
      v-if="closeBtn"
      class="btn__menu--toggle dialog-close-btn"
      :class="[{ whiteBtn: whiteBtn }]"
      @click="closeDialogHandler"
    >
      <img
        v-if="whiteBtn"
        class="dialog-toggle-btn"
        src="@/assets/images/components/ui/btn_explain.png"
        alt="Close"
      />
      <img
        v-else
        class="dialog-toggle-btn"
        src="@/assets/images/layouts/sideBar/btn_menu_toggle.svg"
        alt="Close"
      />
    </button>
  </section>
  <div
    v-if="isVisible && useOverLay"
    class="overlay"
    @click="overlayHandler"
    @keydown="overlayHandler"
  ></div>
</template>

<script setup>
import { watch, ref, defineProps, defineEmits } from "vue";
const emit = defineEmits(["onClose"]);
const props = defineProps({
  className: String,
  style: Object,
  width: Number,
  height: Number,
  isVisible: Boolean,
  useOverLay: Boolean,
  closeBtn: Boolean,
  whiteBtn: Boolean,
});

const isVisible = ref(props.isVisible);
const isCloseEscape = ref(false);
const width = props.width ? `${props.width}rem` : "";
const height = props.height ? `${props.height}rem` : "";

const overlayHandler = () => {
  isVisible.value = false;
  isCloseEscape.value = true;
};

const keydownHandler = (e) => {
  if (e.code === "Escape") {
    isVisible.value = false;
    isCloseEscape.value = true;
  }
};

const closeDialogHandler = () => {
  isVisible.value = false;
  isCloseEscape.value = false;
};

watch(
  () => props.isVisible,
  (newVal) => {
    isVisible.value = newVal;
    isCloseEscape.value = false;
    if (newVal) {
      document.addEventListener("keydown", keydownHandler);
    }
  }
);

watch(isVisible, (newVal) => {
  if (!newVal) {
    document.removeEventListener("keydown", keydownHandler);
    emit("onClose", {
      isVisible: false,
      isCloseEscape: isCloseEscape.value,
    });
  }
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/ui/dialog.scss";
</style>
